import { CclCsrHeader } from '@chewy/ccl-csr-header';

import { useAuthContext } from '@/providers/AuthProvider';

/**
 * Customer service representatives can impersonate users.
 * When they do, isCsr is set to true and this component gives them a link to sign out and release the user's account.
 * Source https://github.com/Chewy-Inc/chewy-component-library/tree/feature/next/packages/ccl-csr-header
 */
const CsrHeader = () => {
  const { isCSR, callerId, customerId, callerLogonId, userLogonId } = useAuthContext();

  return (
    <CclCsrHeader
      adminName={callerLogonId}
      callerId={callerId}
      customerEmail={userLogonId ?? 'Unknown'}
      customerId={customerId}
      isCsr={isCSR}
    />
  );
};

export default CsrHeader;
